import React, { createContext, forwardRef, useContext } from 'react';
import { GridRow } from '@mui/x-data-grid';

export const ExpandedRowContext = createContext(null);
export const EXPANDED_ROW_HEIGHT = 450;

// A normal grid row plus a bounded comparison panel: sorting and virtualization
// continue to operate on the original BOM line, not synthetic quote rows.
export const ExpandableBOMRow = forwardRef(function ExpandableBOMRow(props, ref) {
  const context = useContext(ExpandedRowContext);
  if (!context || context.expanded !== props.rowId) return <GridRow {...props} ref={ref} />;
  return <div className="bomwise-expanded-row" style={{ height: props.rowHeight, width: '100%' }}>
    <GridRow {...props} rowHeight={34} ref={ref} />
    <div className="bomwise-inline-comparison" style={{ height: EXPANDED_ROW_HEIGHT - 34 }}
      role="region" aria-label={context.detailLabel?.(props.row) || `Quotes for line ${props.row.order_index + 1}`}>
      {context.renderDetail(props.row)}
    </div>
  </div>;
});
